import {usePage} from "@inertiajs/react";

export function useFlash(): Record<string, string> {
    const {props} = usePage();

    return props.flash ?? null;
}
